import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.css']
})
export class ComingSoonComponent implements OnInit {
  translate:TranslateService;
  constructor(private router: Router,
    private translateService:TranslateService) { 
    this.translate=translateService;
  }

  ngOnInit() {
  }

  goHome() {
    this.router.navigate(['/home']); // Assuming '/' is your home route path
  }

  login() {
    this.router.navigate(['/auth/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/front-pages/pages/coming-soon/coming-soon.component.ts